import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-error404-page',
  templateUrl: './error404-page.component.html',
  styleUrls: ['./error404-page.component.scss']
})
export class Error404PageComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    @Optional() @Inject(RESPONSE) private response: any,
  ) { }

  ngOnInit(): void {
    // Without this the SSR answered 200 for every unknown URL (soft 404).
    // A status already set during the render (e.g. 503 from a resolver whose
    // backend call timed out) is kept.
    if (
      isPlatformServer(this.platformId) &&
      this.response &&
      !this.response.headersSent &&
      (this.response.statusCode || 200) === 200
    ) {
      this.response.status(404);
    }
  }

}
